import Link from 'next/link';
import Image from 'next/image';

/**
 * The navbar logo: icon plus the GAMERPLUG wordmark from md up. Shared by the
 * public Header and the in-app AppHeader so the two bars match exactly.
 */
export function BrandLogo({ href }: { href: string }) {
  return (
    <Link href={href} className="flex items-center gap-3 group cursor-pointer">
      <div className="relative w-8 h-8 transform group-hover:scale-110 transition-transform duration-300">
        <Image
          src="/logo.png"
          alt="Gamerplug Logo"
          width={32}
          height={32}
          quality={100}
          priority
          className="rounded-lg shadow-[0_0_15px_rgba(220,38,38,0.5)]"
        />
      </div>
      <span className="hidden md:inline font-sans font-extrabold text-2xl tracking-tight italic">
        GAMER<span style={{ color: '#FF0034' }}>PLUG</span>
      </span>
    </Link>
  );
}
